import { render } from "./PanelTipsterRetencion.vue?vue&type=template&id=1d6e3681&scoped=true"
import script from "./PanelTipsterRetencion.vue?vue&type=script&lang=js"
export * from "./PanelTipsterRetencion.vue?vue&type=script&lang=js"

import "./PanelTipsterRetencion.vue?vue&type=style&index=0&id=1d6e3681&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6e3681"]])

export default __exports__